// extracted by mini-css-extract-plugin
module.exports = {"fullImage":"bqZoE","carouselDots":"_5UDjG"};